import type { Root } from "mdast";
import { MARKDOWN_PLACEHOLDER_REGEX } from "./markdown.constants";
import { replacePlaceholdersInChildren } from "./markdown.utilities";

/**
 * A remark plugin that turns each placeholder marker into an inline `<span>` carrying its index.
 *
 * Markers inside a fenced code block are stripped; those in raw `html` or a link destination are left alone.
 * @returns The mdast transformer.
 */
export const remarkPlaceholders = () => {
    return (tree: Root) => {
        // Cloned because `MARKDOWN_PLACEHOLDER_REGEX` is global and shared: a stray `lastIndex` would skip markers.
        const placeholderRegex = new RegExp(MARKDOWN_PLACEHOLDER_REGEX);
        replacePlaceholdersInChildren(tree, placeholderRegex);
    };
};
